/**
 * Custom JavaScript for HHC Friends Theme
 * Fixes and enhancements for Flickity Slider for Desktop View
 */

document.addEventListener('DOMContentLoaded', function() {
  
  /**
   * Fix Flickity positioning for product slideshow on desktop
   * Eliminates the starting offset and ensures proper translateX positioning
   */
  function fixProductSlideshowPositioning() {
    // Wait for Flickity to be available
    if (typeof Flickity === 'undefined') {
      setTimeout(fixProductSlideshowPositioning, 100);
      return;
    }

    // Target all product slideshows
    const productSlideshows = document.querySelectorAll('.product-slideshow');
    
    productSlideshows.forEach(function(slideshow) {
      // Check if this slideshow is already initialized with Flickity
      const flickityInstance = Flickity.data(slideshow);
      
      if (flickityInstance && window.innerWidth >= 1200) {
        // Fix the positioning issues for desktop
        fixFlickityInstance(flickityInstance);
      } else if (!flickityInstance) {
        // If not initialized yet, set up a mutation observer to catch it when it is
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.target.classList.contains('flickity-enabled')) {
              const instance = Flickity.data(mutation.target);
              if (instance && window.innerWidth >= 1200) {
                fixFlickityInstance(instance);
              }
              observer.disconnect();
            }
          });
        });
        
        observer.observe(slideshow, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });
  }

  /**
   * Apply comprehensive fixes to a Flickity instance
   */
  function fixFlickityInstance(instance) {
    // Force pixel positioning instead of percentage
    instance.options.percentPosition = false;
    
    // Ensure left alignment (no centering)
    instance.options.cellAlign = 'left';
    
    // Force cursorPosition to 0 to eliminate starting offset
    instance.cursorPosition = 0;
    
    // Override the setTranslateX method to eliminate cursor position offset
    instance.setTranslateX = function(t, e) {
      // Don't add cursorPosition - keep the raw translation value
      t = this.options.rightToLeft ? -t : t;
      const i = this.getPositionValue(t);
      this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
    };
    
    // Recalculate cell alignment
    instance.setCellAlign();
    
    // Recalculate sizes and positions
    instance.getSize();
    instance.positionCells();
    
    // Reset to first slide and reposition
    instance.x = 0;
    instance.selectedIndex = 0;
    instance.updateSelectedSlide();
    instance.positionSliderAtSelected();
    
    // Force immediate positioning without animation
    instance.slider.style.transform = 'translateX(0px)';
    
    console.log('Flickity positioning fixed - starting at translateX(0px)');
  }

  // Initialize the fix
  fixProductSlideshowPositioning();
  
  // Also run on window resize to handle viewport changes
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(fixProductSlideshowPositioning, 250);
  });

});